module.exports = __webpack_public_path__ + "img/img18.c785164b.png";